import { Box, Chip, Dialog, DialogContent, Divider, Tab, Tabs, Typography } from "@mui/material"
import { BoxFC, BoxFR } from "components/BoxCustom"
import PaperComponent from "components/PaperComponent"
import { DialogHeader } from "components/dialog/DialogHeader"
import React, { useState } from "react"

import { mainChangelog, branchChangelog } from '../../data/mergedChangelog'

// Add / Change / Fix -> Thai label + MUI chip color
const CATEGORY = {
  add: { label: "เพิ่มใหม่", color: "success" },
  change: { label: "ปรับปรุง", color: "info" },
  fix: { label: "แก้ไข", color: "warning" },
}

// Tab 0 = shared (master) changelog, tab 1 = this client branch's own changelog
const TABS = [
  { label: "หลัก (Main)", data: mainChangelog },
  { label: "สาขา (Branch)", data: branchChangelog },
]

const ReleaseList = ({ releases }) => (
  <BoxFC pt={2} gap={3}>
    {releases.map((release, idx) => (
      <BoxFC key={release.version} gap={1}>
        <BoxFR gap={1} alignItems="baseline">
          <Typography variant="h6" color="primary">
            เวอร์ชัน {release.version}
          </Typography>
          {release.date &&
            <Typography variant="body2" color="text.secondary">
              {release.date}
            </Typography>
          }
        </BoxFR>
        <BoxFC gap={0.5} pl={1}>
          {release.items.map((item, i) => {
            const cat = CATEGORY[item.category] || { label: item.category, color: "default" }
            return (
              <BoxFR key={i} gap={1} alignItems="flex-start">
                <Chip label={cat.label} color={cat.color} size="small"
                  sx={{ minWidth: 72, mt: "2px" }} />
                <Typography variant="body2" sx={{ flex: 1 }}>
                  {item.desc}
                </Typography>
              </BoxFR>
            )
          })}
        </BoxFC>
        {idx < releases.length - 1 && <Divider sx={{ mt: 1 }} />}
      </BoxFC>
    ))}
    {releases.length === 0 &&
      <Typography variant="body2" color="text.secondary" textAlign="center">
        ยังไม่มีประวัติการอัปเดต
      </Typography>
    }
  </BoxFC>
)

const ChangeLogDialog = ({ dialogOpen, setDialogOpen }) => {

  const [tabIndex, setTabIndex] = useState(0)

  const handleDialogClose = () => setDialogOpen(false)

  return (
    <Dialog
      open={dialogOpen}
      PaperComponent={PaperComponent}
      aria-labelledby="draggable-dialog-title"
      fullWidth maxWidth='sm'
    >
      <DialogHeader handleDialogClose={handleDialogClose}
        title="ประวัติการอัปเดต (Change Log)"
        onDeleteClick={null}
      />
      <DialogContent>
        <Tabs value={tabIndex} onChange={(e, v) => setTabIndex(v)} variant="fullWidth">
          {TABS.map((tab, i) =>
            <Tab key={i} label={`${tab.label} (${tab.data.length})`} />
          )}
        </Tabs>
        <ReleaseList releases={TABS[tabIndex].data} />
      </DialogContent>
      <Box sx={{ height: 12 }} />
    </Dialog>
  )
}

export default React.memo(ChangeLogDialog)
